module.exports = __webpack_public_path__ + "static/media/logo-cetelem.4ddee2c8.png";